import { NgModule } from '@angular/core';
import { ElementInfoComponent } from './element-info/element-info.component';
import { SharedProviderModule } from '../shared/shared.module';
import { ElementInterestingPropertiesComponent } from './element-interesting-properties/element-interesting-properties.component';
import { NotificationModule } from '../components/notification/notification.module';
import { TrainInfoModule } from '../custom/vrgroup/train-info/train-info.module';
import { StationInfoModule } from '../custom/vrgroup/station-info/station-info.module';
import { ElementDetailsModule } from '../element-details/element-details.module';

@NgModule({
  imports: [
    ElementDetailsModule,
    NotificationModule,
    SharedProviderModule,
    TrainInfoModule,
    StationInfoModule
  ],
  declarations: [ElementInfoComponent, ElementInterestingPropertiesComponent],
  exports: [ElementInterestingPropertiesComponent]
})
export class ElementInfoModule {
}
